import { workerRenderRoute } from './cpuRenderRoute';

// A full-frame worker tile may omit a lower row only when its existing
// pixel-center expression produces the exact negation of the upper row.
// Both rows then use the same x coordinates and conjugate c values.
export function conjugatePartnerRow(row, height, yBase, yScale, y0) {
  const partner = height - 1 - row;
  if (partner < 0 || partner >= row || !Number.isFinite(y0)) return -1;
  const partnerY0 = yBase + (partner + 0.5) * yScale;
  return Number.isFinite(partnerY0) && Object.is(y0, -partnerY0) ? partner : -1;
}

export function fullConjugateRowMap({ canvasWidth: width, canvasHeight: height,
  xRange, yRange, colorParams }) {
  // Preserve the whole-count cache, period-3 worker route, and pan protocol.
  if (!Number.isInteger(width) || width < 1 ||
      !Number.isInteger(height) || height < 2 ||
      !Array.isArray(xRange) || !Array.isArray(yRange) ||
      xRange.length !== 2 || yRange.length !== 2 ||
      !xRange.every(Number.isFinite) || !yRange.every(Number.isFinite) ||
      workerRenderRoute(xRange, yRange, colorParams) !== 'ordinary' ||
      !(yRange[0] < 0 && yRange[1] > 0)) return null;
  const xScale = (xRange[1] - xRange[0]) / width;
  const yScale = (yRange[1] - yRange[0]) / height;
  if (!Number.isFinite(xScale) || xScale <= 0 ||
      !Number.isFinite(yScale) || yScale <= 0) return null;
  const partners = new Int32Array(height);
  partners.fill(-1);
  let reusedRows = 0;
  for (let row = Math.ceil(height / 2); row < height; row++) {
    const y0 = yRange[0] + (row + 0.5) * yScale;
    const partner = conjugatePartnerRow(row, height, yRange[0], yScale, y0);
    partners[row] = partner;
    reusedRows += partner >= 0;
  }
  return reusedRows ? { partners, reusedRows } : null;
}

export function fillConjugateRows(pixels, width, partners) {
  const bytesPerRow = width * 4;
  for (let row = Math.ceil(partners.length / 2); row < partners.length; row++) {
    const partner = partners[row];
    if (partner < 0) continue;
    const source = partner * bytesPerRow;
    pixels.set(pixels.subarray(source, source + bytesPerRow), row * bytesPerRow);
  }
}
